import PropTypes from 'prop-types';
import IconLoading from '@spotahome/marketplace-common/src/LEGACY/javascripts/ui/icon/icon-loading';
import { ExtendedLandlordInformationContent } from '@spotahome/ui-library';
import { LandlordScoringShape } from '@spotahome/ui-library/src/tenant/constants/shapes';

import { useLandlordInformation } from '../../context/LandlordInformationContext';

import { ListingSectionObservable } from '../ListingSection';

import OtherProperties from './OtherProperties';

import './ExtendedLandlordInformation.scss';

const noop = () => {};

const ExtendedLandlordInformation = ({
  currentListingId,
  landlordHomecards,
  landlordScoring = {},
  renderContactContent = noop
}) => {
  const { loading, error, landlordInformation } = useLandlordInformation();

  const renderOtherProperties = () => {
    if (!landlordHomecards?.length) {
      return null;
    }

    const homecardsWithoutCurrent = landlordHomecards.filter(
      homecard => homecard.id !== currentListingId
    );

    return <OtherProperties homecards={homecardsWithoutCurrent} />;
  };

  return (
    <ListingSectionObservable
      section="aboutLandlord"
      className="extended-landlord-information"
    >
      <div className="extended-landlord-information__content">
        {loading && <IconLoading />}
        {landlordInformation && !error && (
          <ExtendedLandlordInformationContent
            type={landlordInformation.type}
            joiningDate={landlordInformation.firstListingDate}
            listingsPublished={landlordInformation.listingsPublished}
            numberOfBookingRequests={
              landlordInformation.numberOfBookingRequests
            }
            averageResponseTime={landlordInformation.averageResponseTime}
            languages={landlordInformation.languages}
            renderOtherProperties={renderOtherProperties}
            landlordScoring={landlordScoring}
            renderContactContent={renderContactContent}
          />
        )}
      </div>
    </ListingSectionObservable>
  );
};

ExtendedLandlordInformation.propTypes = {
  currentListingId: PropTypes.number.isRequired,
  landlordHomecards: PropTypes.arrayOf(PropTypes.object).isRequired,
  landlordScoring: PropTypes.shape(LandlordScoringShape),
  renderContactContent: PropTypes.func
};

export default ExtendedLandlordInformation;
